import React from "react";
import Button from "../../../shared/components/Button/Button";
import ProgressBar from "../../../shared/components/ProgressBar/ProgressBar";
import { useBlingProductSync } from "../hooks/useBlingProductSync";
import { useBlingStockSync } from "../hooks/useBlingStockSync";
import { batchProgress } from "../utils/progress";

const ErrorList = ({ errors }) =>
  errors.length > 0 && (
    <ul className="bling-page__errors">
      {errors.map((e, i) => (
        <li key={`${e.code}-${i}`}>
          <strong>{e.code}</strong>: {e.error}
        </li>
      ))}
    </ul>
  );

// Barra "N de total" de um envio em lotes; some quando ainda não começou.
const SyncProgress = ({ title, done, remaining, syncing, detail }) => {
  if (!syncing && remaining === null) return null;
  const { total, percent } = batchProgress(done, remaining);
  const finished = !syncing && !remaining;
  return (
    <ProgressBar
      value={finished ? 100 : percent}
      label={
        finished
          ? `${title}: concluído (${done})`
          : `${title}: ${done} de ${total || "…"}`
      }
      detail={detail}
    />
  );
};

// Site → Bling: cadastro (com fotos e variação cor × tamanho) e estoque.
const BlingProductSyncPanel = ({ disabled }) => {
  const products = useBlingProductSync();
  const stock = useBlingStockSync();
  const busy = products.syncing || stock.syncing;

  return (
    <div className="bling-page__panel">
      <h5>Produtos e estoque</h5>
      <p className="text-muted bling-page__hint">
        O site é a fonte da verdade. <strong>Enviar produtos</strong> manda os
        produtos novos ou alterados (fotos de cada cor, NCM, variações e
        estoque) e inativa no Bling os excluídos aqui.{" "}
        <strong>Enviar estoque</strong> acerta o saldo de todos os produtos e
        recria as variações que mudaram de cor ou tamanho.
      </p>
      <div className="bling-page__actions">
        <Button onClick={products.start} disabled={disabled || busy}>
          {products.syncing ? "Enviando produtos…" : "Enviar produtos"}
        </Button>
        <Button
          variant="secondary"
          onClick={stock.start}
          disabled={disabled || busy}
        >
          {stock.syncing ? "Enviando estoque…" : "Enviar estoque"}
        </Button>
      </div>

      <SyncProgress
        title="Produtos"
        done={products.done}
        remaining={products.remaining}
        syncing={products.syncing}
        detail={
          products.current
            ? `Último enviado: ${products.current}`
            : "Começando…"
        }
      />
      <ErrorList errors={products.errors} />

      <SyncProgress
        title="Estoque"
        done={stock.processed}
        remaining={stock.remaining}
        syncing={stock.syncing}
        detail={`${stock.updated} saldos atualizados no Bling`}
      />
      <ErrorList errors={stock.errors} />
    </div>
  );
};

export default BlingProductSyncPanel;
